import { render } from "./OrganisationAbout.vue?vue&type=template&id=3500ce5c"
import script from "./OrganisationAbout.vue?vue&type=script&lang=js"
export * from "./OrganisationAbout.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__